import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Section} from 'components/organisms';
import {Comments} from 'components/atoms';
import {Box, Divider, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';

import propTypes from 'helpers/propTypes';
import {NextPrev} from './components';
import {
  Assessment,
  CheckForUnderstanding,
  Exercise,
  Project,
  SlidesContent,
  VideoContent,
  TextContent,
} from './contentTypes';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    height: '100%',
    width: '100%',
  },
  section: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(4),
    },
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    display: 'block',
  },
  textContent: {},
}));

const ContentTypeMultiplexer = ({page, children}) => {
  const ContentType = {
    Assessment,
    CheckForUnderstanding,
    Exercise,
    Project,
    GoogleSlides: SlidesContent,
    HTMLSlides: SlidesContent,
    TextContent,
    VideoContent,
  };

  const Component = ContentType[page.contentType];
  return <Component page={page}>{children}</Component>;
};

const Course = ({themeMode, pageContext, children}) => {
  const {
    page,
    page: {course, topic, nextPage},
  } = pageContext;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Section className={classes.section}>
        <Box mb={2}>
          <Typography color="textSecondary" className={classes.title}>
            {topic.title} → {page.title}
          </Typography>
        </Box>
        <ContentTypeMultiplexer page={page}>{children}</ContentTypeMultiplexer>
        <Box mt={15}>
          <NextPrev next={nextPage} />
        </Box>
        <Box mt={18} mx={8}>
          <Divider />
        </Box>
        <Box mt={4}>
          <Comments
            repo={course.repo}
            page={`${topic.title} - ${page.title}`}
            themeMode={themeMode}
          />
        </Box>
      </Section>
    </div>
  );
};

Course.propTypes = {
  pageContext: PropTypes.shape({
    page: propTypes.page.isRequired,
  }),
};

export default Course;
